import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';


// Query Keys
export const algoQueryKeys = {
  all: ['algos'],
  list: (params) => [...algoQueryKeys.all, 'list', params],
};

// 알고리즘 목록 조회
export const useAlgoList = (params = {}) => {
  return useQuery({
    queryKey: algoQueryKeys.list(params),
    queryFn: async () => {
      const response = await api.get('/drivecore/cblmodule/api/CblModule', { params });
      response.totalCount = response?.Total || response?.total || response.length;
      return response;
    },
  });
};